import { useRef, useState } from 'react';
import { useMutation } from 'react-query';
import Loading from '../../Loading';
import { createHands } from '@/api/query/hands';
import PopUp from '../../PopUp';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import { HAND_DECISION } from '@/common/constants/handDecision';
import {
	ButtonsWrapper,
	LetterCounterWrapper,
	P,
	PopUpWrapper,
	Send,
	SubTitlePopUp,
	TextArea,
	TitlePopUp,
	Skip,
} from './HandsPopUp.styled';

const HandsPopUp = ({ type, forWhat, decision, setDecision, userVoice }) => {
	const [lengthCounter, setLengthCounter] = useState(0);
	const { thanksForGrading, subtitle, subtitle2, skip, send } =
		useLanguageData('hands');

	const messageRef = useRef();

	const handleAddHandMutation = useMutation({
		mutationFn: (payload) => createHands(payload),
	});

	const handleAddHand = (e) => {
		e?.preventDefault();

		const form = new FormData();

		form.set('decision', decision);
		form.set('type', type);
		form.set('for', forWhat);

		form.set('window_size', `${window?.innerWidth}x${window?.innerHeight}`);
		form.set('device_description', window?.navigator?.userAgent);

		if (messageRef?.current?.value) {
			form.set('message', messageRef?.current?.value);
		}

		if (decision === HAND_DECISION.DOWN && userVoice) {
			form.set('file', userVoice);
		}

		handleAddHandMutation.mutate(form);
		setDecision(null);
	};

	const handleChange = (e) => {
		const message = messageRef.current.value;

		if (message.length > 300) {
			messageRef.current.value = message.slice(0, 300);
			return;
		}

		setLengthCounter(() => message.length);
	};

	return (
		<>
			{handleAddHandMutation.isLoading && <Loading />}
			<PopUp closeIcon={false}>
				<PopUpWrapper onSubmit={handleAddHand}>
					<TitlePopUp>{thanksForGrading}</TitlePopUp>{' '}
					<SubTitlePopUp>{subtitle}</SubTitlePopUp>
					<P>{subtitle2}</P>
					<TextArea
						ref={messageRef}
						onChange={(e) => handleChange(e)}
						required={true}
					/>
					<LetterCounterWrapper>{lengthCounter} / 300</LetterCounterWrapper>
					<ButtonsWrapper>
						<Skip type='button' onClick={() => handleAddHand()}>
							{skip}
						</Skip>
						<Send type='submit'>{send}</Send>
					</ButtonsWrapper>
				</PopUpWrapper>
			</PopUp>
		</>
	);
};

export default HandsPopUp;
